<style lang="scss">
  @use "../../../../assets/css/design-system/utils";
  @use "../../../../assets/css/design-system/mixins";

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: utils.in_rem(8px);
    align-items: center;
    .title {
      @include mixins.title3();
    }
    .extra-info {
      @include mixins.h5();
      text-align: right;
    }
  }
</style>

<script>
  import AddLicensesChip from "./AddLicensesChip.svelte";
  import TrialChip from "./TrialChip.svelte";

  let { title, status, onclick = null } = $props();
</script>

<div class="header">
  <div class="title">{title}</div>
  <div class="extra-info">
    {#if ["trial", "trialEnded"].includes(status)}
      <TrialChip {status} />
    {:else if onclick}
      <AddLicensesChip {onclick} />
    {/if}
  </div>
</div>
